import {
  SBlankWrapper,
  SCardImageWrapper,
  SCardWrapper,
  SImage,
  STemplateName,
} from './FutureMessageTemplateModal.styled'
import { FutureMessageTemplate } from 'components/futureMessage/FutureMessageUtils'
import { Icon } from 'components/icon'
import { colors } from 'utils/colors'

export function FutureMessageTemplateCard({
  onClick,
  template,
}: {
  template: FutureMessageTemplate
  onClick: () => void
}) {
  return (
    <SCardWrapper onClick={onClick}>
      <SCardImageWrapper>
        {template.modalImage ? (
          <SImage src={template.modalImage} />
        ) : (
          <SBlankWrapper>
            <Icon name="Plus" size="2rem" color={colors.blue[500]} />
          </SBlankWrapper>
        )}
      </SCardImageWrapper>
      <STemplateName variant="bodyBold">{template.name}</STemplateName>
    </SCardWrapper>
  )
}
